<div class="container">
    <div class="content">
        <div class="title-container">
            <img src="../../../assets/logo01-b.png" alt="Travelex UK" />

            <div class="title-text-container">
                <span class="title-text">Foreign Exchange Services</span>
            </div>
        </div>
        <div class="top-banner">
            <img src="../../../assets/quienes-somos.jpg" alt="Travelex UK" />
            <div class="top-banner-curved-edge"></div>
        </div>

        <div class="page-content">
            <div class="message-container">
                <span class="message-title-text">Payment Error</span>
            </div>

            <div class="success-text-container">
                <p class="personal-field-title">An error occured while processing your payment.</p>
                <p class="personal-field-title">Click on the button below to place a new order.</p>
            </div>
    
            <div class="btn-container">
                <button class="btn-style" mat-raised-button color="custom-color" (click)="navigateToHome()">
                    New Order
                </button>
            </div>
        </div>
    </div>
</div>